import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { CommonService } from "src/app/core/services/common.service";
import { NotifierService } from "angular-notifier";
import { BaseComponent } from "src/app/shared/components/base/base.component";
import { Message } from "src/app/core/class/message";
import { ActivatedRoute, Router } from "@angular/router";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { map, startWith } from "rxjs/operators";
import { BehaviorSubject, forkJoin, Observable, Subject } from "rxjs";
import { WarningComponent } from "src/app/shared/components/warning/warning.component";
import { MatAccordion, MatDialog } from "@angular/material";
import { DialogGroupNameFieldComponent } from "./dialog-difference-process/dialog-group-name-field/dialog-group-name-field.component";
import { DialogChangeNameFieldComponent } from "./dialog-difference-process/dialog-change-name-field/dialog-change-name-field.component";
import { FieldConfig } from "src/app/shared/models/field-config.model";
import { DocumentTemplateService } from "src/app/core/services/document-template.service";
import { DocumentTemplate } from "src/app/shared/models/document-template.model";
import { DcFieldConfigService } from "src/app/core/services/dc-field-config.service";
import { FieldConfigComponent } from "src/app/modules/dashboard/home/home-enterprise/document-management/document-template-form/field-config/field-config.component";
import { TemplateFileService } from "src/app/core/services/template-file.service";
import { TemplateFile } from "src/app/shared/models/template-file.model";
import { DcFileDTO } from "src/app/shared/models/dc-file-dto.model";
import { ToastrService } from "ngx-toastr";
import { TemplateFieldConfig } from "src/app/shared/models/template-field-config.model";
import { TemplateFieldConfigService } from "src/app/core/services/template-field-config.service";
import { DialogErrorComponent } from "./dialog-error/dialog-error.component";
import { DialogPreviewPdfComponent } from "../dialog-preview-pdf/dialog-preview-pdf.component";
import { WarningWithSkipComponent } from "src/app/shared/components/warning-with-skip/warning-with-skip.component";
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";
import { DocumentTypeService } from "src/app/core/services/document-type.service";
import { ErrorCode } from "src/app/core/constants/error-code";
import { Location } from "@angular/common";
import { NotificationService } from "src/app/core/services/notification.service";
import { SignatureConfigService } from "src/app/core/services/signature-config.service";
import { SignatureConfig } from "src/app/shared/models/signature-config.model";
import { WarningErrorFileComponent } from "src/app/shared/components/warning-error-file/warning-error-file.component";
import { CreateContractService } from "src/app/core/services/create-contract.service";
import { UserWithDepartmentEntity } from "src/app/core/class/UserEntity";
import { EnumRoleUser } from "src/app/core/constants/common";

@Component({
  selector: "app-document-template-form",
  templateUrl: "./document-template-form.component.html",
  styleUrls: ["./document-template-form.component.scss"],
})
export class DocumentTemplateFormComponent
  extends BaseComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatAccordion, { static: true }) accordion: MatAccordion;
  @ViewChildren("focusInput") focusInput;
  @ViewChild("fieldConfig", { static: true })
  appFieldConfig: FieldConfigComponent;
  @ViewChild("contentEmptyTable", { static: false })
  contentEmptyTable: TemplateRef<any>; // Set no display No_data on Nz-Table

  public mode: "edit" | "create" | "draft" = "create";

  public templateInformationFormGroup: FormGroup;
  public fileName: string = "";

  public listTypes: Observable<any>;
  public listServiceTypes: any[] = [];
  public selectedServiceType: any = {};
  public searchTypeCtrl: FormControl = new FormControl(null);

  public dataNameField: FieldConfig[];
  public dataGroupField: FieldConfig[];
  public groupBtnDisplay: boolean;
  public moveBtnDisplay: boolean = true;
  public disableButtonForm: boolean = false;
  public dataFieldConfigChange: boolean = false;

  public process_click: boolean = false;

  protected _onDestroy = new Subject<void>();

  public dataRow: FieldConfig;
  public dataGroup: FieldConfig;

  public documentTemplate: DocumentTemplate;
  public templateId: number;
  public templateFile: TemplateFile;
  public fileIsError: "oversize" | "file_type" | "difference" = null;
  public requiredFileError: boolean = false;
  public errorForFile = new BehaviorSubject<string>("");
  public checkRequiredFile = new BehaviorSubject<boolean>(false);
  public loadingSearchType: boolean = false;
  public fileNameChange: boolean = false;
  public panelStatus: boolean = true;
  public checkErrorCode = new BehaviorSubject<boolean>(false);
  public checkDisplayDeleteBtn = false;
  public tplModal: NzModalRef;
  public notPermission: boolean = false;
  public isDraft: boolean = false;
  public documentTypeId = null;

  public listSignatureConfig: SignatureConfig[] = [];
  public listSignatureConfigCustomer: SignatureConfig[] = [];
  RECORD_USER_PERFORM_SIGN: UserWithDepartmentEntity[] = [];
  OLD_RECORD_USER_PERFORM_SIGN: [] = []
  selectedIndex = 0
  configFlowSignList: any = [];
  enterpriseSign: any
  @HostListener("submit")
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll(
      ".mat-form-field-invalid .mat-input-element,.mat-select-invalid"
    );
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }

  constructor(
    private dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    public documentTypeService: DocumentTypeService,
    public documentTemplateService: DocumentTemplateService,
    public dcFieldConfigService: DcFieldConfigService,
    public templateFileService: TemplateFileService,
    public toast: ToastrService,
    public templateFieldConfigService: TemplateFieldConfigService,
    private el: ElementRef,
    private modalService: NzModalService,
    private location: Location,
    private notificationService: NotificationService,
    private signatureConfigService: SignatureConfigService,
    private createContractService: CreateContractService
  ) {
    super(commonService, message);
    this.notifier = notifier;
    this.createContractService.recordsUserPerformSign.subscribe(res => {
      this.RECORD_USER_PERFORM_SIGN = res
    })
  }

  ngOnDestroy(): void {
    this.notificationService.unsubscribeErrorService();
    this.createContractService.recordsUserPerformSign.next([]);
  }

  ngOnInit() {
    this.getDataForCreateMergeField();
    window.scrollTo(0, 0);
    this.initForm();
    this.getServiceType();
    this.searchDocumentType();
    this.activatedRouter.paramMap.subscribe((params) => {
      const id = params.get("id") ? params.get("id") : null;
      this.getDataById(id);
      this.documentTypeId = id;
    });
    this.notificationService.subscribeErrorService();
  }

  updateSignatureConfigCustomer(): void {
    this.listSignatureConfigCustomer = this.listSignatureConfig.filter(
      signature => signature.object === "CUSTOMERAPPROVER" || signature.object === "CUSTOMER"
    );
  }

  configInitFlowSignListChange(res){
    let newList = this.OLD_RECORD_USER_PERFORM_SIGN 
      ? this.OLD_RECORD_USER_PERFORM_SIGN.map((data: any) => ({
        ...data,
        signConfig: data.signConfig ? (typeof data.signConfig === 'string' ? this.setDataSignConfig(JSON.parse(data.signConfig)) : this.setDataSignConfig(data.signConfig)) : { resize: false, showImage: data.isSignDigitalCertificate ? true : (data.role == EnumRoleUser.USER_SIGN ? true : false) }
      })) 
      : res.map((data) => ({
        ...data,
        signConfig: data.signConfig ? (typeof data.signConfig === 'string' ? this.setDataSignConfig(JSON.parse(data.signConfig)) : this.setDataSignConfig(data.signConfig)) : { resize: false, showImage: data.isSignDigitalCertificate ? true : (data.role == EnumRoleUser.USER_SIGN ? true : false) }
      }))
      
    if (this.listSignatureConfig && newList) {
      this.enterpriseSign = newList.find(item => item.typeInSignFlow === 'SIGN');
      // if (!enterprise) {
      //   for (let i = 0; i < this.listSignatureConfig.length; i++) {
      //     if (this.listSignatureConfig[i].object === "ENTERPRISE") {
      //       this.listSignatureConfig[i]['enterprise'] = '';
      //       break;
      //     }
      //   }
      // } else {
      //   for (let i = 0; i < this.listSignatureConfig.length; i++) {
      //     if (this.listSignatureConfig[i].object === "ENTERPRISE") {
      //       this.listSignatureConfig[i]['enterprise'] = enterprise.name;
      //       break;
      //     }
      //   }
      // }
    }
  }

  configFlowSignListChange(res){
    this.RECORD_USER_PERFORM_SIGN = res;
    if (this.listSignatureConfig && res) {
      this.enterpriseSign = this.RECORD_USER_PERFORM_SIGN.find(item => item.role === EnumRoleUser.USER_SIGN);
    }
    //   if (!enterprise) {
    //     for (let i = 0; i < this.listSignatureConfig.length; i++) {
    //       if (this.listSignatureConfig[i].object === "ENTERPRISE") {
    //         this.listSignatureConfig[i]['enterprise'] = '';
    //         break;
    //       }
    //     }
    //   } else {
    //     for (let i = 0; i < this.listSignatureConfig.length; i++) {
    //       if (this.listSignatureConfig[i].object === "ENTERPRISE") {
    //         this.listSignatureConfig[i]['enterprise'] = enterprise.name;
    //         break;
    //       }
    //     }
    //   }
    // }else{
    //   this.listSignatureConfig = []
    // }
    this.OLD_RECORD_USER_PERFORM_SIGN = res ? res.map(item => {
      let newItem = {
        userId : item.userId,
        typeInSignFlow : item.role === EnumRoleUser.USER_SIGN ? 'SIGN' : 'VERIFY',
        order: item.order,
        role: item.role + '',
        name: item.name,
        departmentName: item.departmentName,
        departmentId: item.departmentId,
        isSignDigitalCertificate: item.isSignDigitalCertificate ? item.isSignDigitalCertificate : false,
        signConfig: item.signConfig ? (typeof item.signConfig === 'string' ? this.setDataSignConfig(JSON.parse(item.signConfig)) : this.setDataSignConfig(item.signConfig)) : { resize: false, showImage: item.isSignDigitalCertificate ? true : (item.role == EnumRoleUser.USER_SIGN ? true : false) }
      }
      return newItem;
    }) : []
    console.log('asd', this.OLD_RECORD_USER_PERFORM_SIGN);
  }
  ngAfterViewInit(): void {
    setTimeout((_) => this.focusInput.first.nativeElement.focus());
  }

  initForm() {
    this.templateInformationFormGroup = new FormGroup({
      code: new FormControl("", [
        Validators.required,
        Validators.maxLength(50),
        // Validators.pattern("^[0-9 _ ,]*$"),
      ]),
      name: new FormControl("", [Validators.required]),
      type: new FormControl("", [Validators.required]),
      description: new FormControl("", []),
    });
  }

  uploadFile() {
    const inputFile = document.getElementById("file");
    inputFile.click();
  }

  getMergeField() {
    this.documentTypeService
      .checkPermission(this.documentTemplate.id)
      .subscribe((res) => {
        if (res && res.code === ErrorCode.NotPermissionTemplate) {
          this.toast.error(this.message.getMessage('messages.check_permission'));
          return;
        }
        if (res && res.success) {
          this.disableButtonForm = true;
          const dialog = this.dialog.open(WarningWithSkipComponent, {
            width: "40%",
            data: this.message.getMessage("messages.confirm_get_merge_field"),
          });
          dialog.afterClosed().subscribe((ref) => {
            this.disableButtonForm = false;
            if (ref === "accept") {
              this.resetFieldConfig("get");
            } else if (ref === "decline") {
              this.addFieldConfigWithMergeFields();
            }
          });
        }
      });
  }

  isShowClearButton(field: string) {
    return this.templateInformationFormGroup &&
      this.templateInformationFormGroup.get(field) &&
      this.templateInformationFormGroup.get(field).value
      ? true
      : false;
  }

  clearData(field: string) {
    return this.templateInformationFormGroup.get(field).patchValue(null);
  }

  initFormControlSearch(serviceType: number) {
    this.getServiceType(serviceType);
  }

  getServiceType(serviceType?: number): void {
    const enterpriseId = localStorage.getItem("enterpriseId");
    this.documentTypeService.getServiceTypesAll(enterpriseId)
      .subscribe((result) => {
        const { data } = result;
        this.listServiceTypes = data;
        this.searchTypeCtrl.patchValue("");
        this.loadingSearchType = false;
        if (this.documentTypeId && serviceType) {
          this.selectedServiceType = this.listServiceTypes.find(serve => serve.id === serviceType);
        }
      });
  }

  isError(formControl: string, validation: string) {
    return (
      this.templateInformationFormGroup.controls[formControl].errors &&
      this.templateInformationFormGroup.controls[formControl].errors[validation]
    );
  }

  openChangeDialog() {
    const dialogRef = this.dialog.open(DialogChangeNameFieldComponent, {
      width: "40%",
      data: this.dataNameField,
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.dataRow = res;
      }
    });
  }

  openGroupDialog() {
    const dialogRef = this.dialog.open(DialogGroupNameFieldComponent, {
      width: "40%",
      data: this.dataGroupField,
    });

    dialogRef.afterClosed().subscribe((rs) => {
      if (rs) {
        this.dataGroup = rs;
      }
      dialogRef.close();
    });
  }

  displayProcessButton(res: boolean) {
    this.process_click = res;
  }

  getNameField(res: FieldConfig[]) {
    this.dataNameField = res;
  }

  getGroupField(res: FieldConfig[]) {
    this.dataGroupField = res;
  }

  isGroupBtnDisplay(res: boolean) {
    this.groupBtnDisplay = res;
  }

  isMoveBtnDisplay(res: boolean) {
    if (res == false) {
      this.moveBtnDisplay = res;
    }
  }

  isDialogMergeFieldClick(res: boolean) {
    this.disableButtonForm = res;
  }

  isDisplayBtnForm(res: boolean) {
    this.disableButtonForm = res;
  }

  displayDeleteBtn(res: boolean) {
    this.checkDisplayDeleteBtn = res;
  }

  saveDocumentTemplate() {
    this.sortOrderApproveSign();
    // this.checkErrorCode.next(true);
    if (this.templateInformationFormGroup.invalid || !this.templateFile) {
      this.templateInformationFormGroup.markAllAsTouched();
      if (!this.templateFile) {
        this.requiredFileError = true;
      }
      return;
    }
    let documentTemplate = this.documentTemplate;

    if (this.mode === "create" || this.mode === "draft") {
      documentTemplate.status = true;
    }

    if (documentTemplate.isDraft) {
      documentTemplate.isDraft = false;
    }

    this.saveDataToObject(documentTemplate);
    documentTemplate.configFlowSignList = [...this.OLD_RECORD_USER_PERFORM_SIGN.map((data: any) => ({
      ...data,
      signConfig: JSON.stringify(data.signConfig)
    }))] as any;
    this.documentTemplateService
      .saveDocumentTemplate(documentTemplate)
      .subscribe((response) => {
        if (response && response.code === ErrorCode.NotPermissionTemplate) {
          this.toast.error(this.message.getMessage('messages.check_permission'));
          return;
        }
        if (!response) {
          if (this.mode === "create") {
            this.toast.error(
              this.message.getMessage("messages.save_document_template_error")
            );
          } else {
            this.toast.error(
              this.message.getMessage("messages.update_document_template_error")
            );
          }
          return;
        }
        if (response.message === "Mã mẫu đã tồn tại") {
          this.templateInformationFormGroup.controls.code.setErrors({
            codeError: true,
          });
          return;
        }
        if (!window.history.length) {
          this.router.navigateByUrl("/home-enterprise/document-template");
        } else {
          this.location.back();
        }
        if (this.mode === "create") {
          this.toast.success(
            this.message.getMessage("messages.save_document_template_success")
          );
        } else
          this.toast.success(
            this.message.getMessage("messages.update_document_template_success")
          );
      });
    // this.checkErrorCode.subscribe((res) => {
    //   if (res == true) {
    //     this.templateInformationFormGroup.controls.code.setErrors({
    //       codeError: true,
    //     });
    //   }
    // });
    // this.router.navigate(["/home-enterprise/document-template"]);
  }

  saveDataToObject(object: DocumentTemplate): DocumentTemplate {
    const controls = this.templateInformationFormGroup.controls;
    object.code = controls.code.value;
    object.name = controls.name.value;
    object.description = controls.description.value;
    object.serviceType = controls.type.value;
    return object;
  }

  getDataById(id: string) {
    this.documentTemplateService
      .getDocumentTemplateById(id)
      .subscribe((response) => {
        if (!response || !response.data) {
          this.checkErrorCodeApi(response);
          return;
        }
        const documentTemplate: DocumentTemplate = response.data;
        this.isDraft = documentTemplate.isDraft;
        const controls = this.templateInformationFormGroup.controls;
        controls.name.patchValue(
          documentTemplate.name ? documentTemplate.name : null
        );
        controls.code.patchValue(
          documentTemplate.code ? documentTemplate.code : null
        );
        controls.description.patchValue(
          documentTemplate.description ? documentTemplate.description : null
        );
        controls.type.patchValue(
          documentTemplate.serviceType ? documentTemplate.serviceType : null
        );
        this.documentTemplateService.typeforUpdateDocumentPage.subscribe(
          (res) => {
            if (res == "create") {
              this.mode = "create";
            } else {
              if (!documentTemplate.isDraft) {
                this.mode = "edit";
              }
              if (documentTemplate.isDraft) {
                this.mode = "draft";
              }
            }
          }
        );
        this.documentTemplate = documentTemplate;
        this.templateId = documentTemplate.documentTemplateId
          ? documentTemplate.documentTemplateId
          : null;
          this.configFlowSignList = response.data.configFlowSignList;
        this.signatureConfigService
          .getAllSignature(this.templateId)
          .subscribe((res) => {
            if (res && res.data) {
              this.listSignatureConfig = res.data;
              this.listSignatureConfig.forEach((signnature) => {
                signnature.pageDatas = [];
                signnature.positions.forEach((position) => {
                  if (!signnature.pageDatas.includes(position.page)) {
                    signnature.pageDatas.push(position.page);
                  }
                });
                return signnature;
              });
              this.updateSignatureConfigCustomer();
              this.configInitFlowSignListChange(response.data.configFlowSignList)
            }
          });
        this.templateFileService
          .getTemplateFile(this.templateId)
          .subscribe((response) => {
            if (response && response.code === ErrorCode.NotPermissionTemplate) {
              this.toast.error(this.message.getMessage('messages.check_permission'));
              return;
            }
            if (!response || !response.data || !response.data.length) {
              return;
            }
            this.templateFile = response.data[0];
            this.fileName =
              this.templateFile.file && this.templateFile.file.name
                ? this.templateFile.file.name
                : null;
          });
        this.initFormControlSearch(documentTemplate.serviceType);
      });
  }

  deleteFieldConfigs() {
    this.disableButtonForm = true;
    const warnDialog = this.dialog.open(WarningComponent, {
      width: "40%",
      data: this.message.getMessage("messages.confirm_delete_field_configs"),
    });
    warnDialog.afterClosed().subscribe((ref) => {
      this.disableButtonForm = false;
      if (ref) {
        this.appFieldConfig.deleteFieldConfigs();
      }
    });
  }

  async onChangeFile(event: any) {
    // this.signatureConfigService.deleteSignature(this.templateId).toPromise();
    this.fileNameChange = true;
    this.requiredFileError = false;
    const temp = (<HTMLInputElement>document.getElementById("file")).files[0];
    const accept: RegExp = /(\.docx)$/;
    if (!accept.exec(temp.name)) {
      this.toast.error(this.message.getMessage("messages.error_file_type_docx"));
      return;
    }
    if (temp.size > 10000000) {
      this.toast.error(this.message.getMessage("messages.error_file_size"));
      return;
    }
    // this.fileName = temp.name;
    const base64 = await this.getBase64(temp);
    const dcFileDto: DcFileDTO = DcFileDTO.build();
    dcFileDto.base64 = base64
      .toString()
      .replace(`data:${temp.type};base64,`, "");
    dcFileDto.contentType = temp.type;
    dcFileDto.name = temp.name;
    if (this.templateFile) {
      dcFileDto.fileId = this.templateFile.file.fileId;
    }
    this.templateFileService
      .saveFile(this.templateId, [dcFileDto])
      .subscribe((response) => {
        if (!response) {
          return;
        }
        if (response && response.code === ErrorCode.NotPermissionTemplate) {
          this.toast.error(this.message.getMessage('messages.check_permission'));
          return;
        }
        if (response.code === ErrorCode.FileContentIsDenied) {
          this.toast.error(this.message.getMessage("messages.error_content_file"));
          return;
        }
        if (response.code === ErrorCode.MergeFieldError) {
          const dialog = this.dialog.open(WarningErrorFileComponent, {
            width: "50%",
            data: JSON.parse(response.message),
          });
          return;
        }
        // console.log("response", response);
        let tempSignature = response.data && response.data[0] && response.data[0].signatures
          ? JSON.parse(response.data[0].signatures)
          : [];
        if (tempSignature.length) {
          tempSignature.forEach((item, index) => {
            item.templateId = this.templateId;
            if (!item.object) {
              if (index !== 0) {
                item.object = "CUSTOMER";
              } else if (index === 0) {
                item.object = "ENTERPRISE";
              }
            }
            if (item.positions.length) {
              item.positions.forEach((position) => {
                position.width = 300;
                position.height = 136;
                position.main = false;
              });
              item.positions[0].main = true;
            }
          });
          this.signatureConfigService
            .saveSignature(this.templateId, tempSignature)
            .subscribe((res) => {
              if (res && res.data) {
                this.listSignatureConfig = res.data;
                this.listSignatureConfig.forEach((signnature) => {
                  signnature.pageDatas = [];
                  signnature.positions.forEach((position) => {
                    if (!signnature.pageDatas.includes(position.page)) {
                      signnature.pageDatas.push(position.page);
                    }
                  });
                  return signnature;
                });
                this.updateSignatureConfigCustomer();
                this.configInitFlowSignListChange(this.configFlowSignList)
              }
            });
        } else {
          this.listSignatureConfig = [];
        }
        // if (response.message === "File content is denied") {
        //   this.toast.error(
        //     this.message.getMessage("messages.error_file_type")
        //   );
        //   return;
        // }
        this.checkRequiredFile.next(false);
        const file = response.data[0];
        if (!file.mergeable) {
          // this.showErrorFile("difference");
          // this.fileIsError = "difference";
          this.toast.error(
            this.message.getMessage("messages.error_track_change")
          );
          return;
        }
        if (this.templateFile) {
          this.toast.success(
            this.message.getMessage("messages.upload_success")
          );
          this.fileName = temp.name;
          this.fileIsError = null;
          this.templateFile.file = file;
          this.requiredFileError = false;
          this.openDialogReloadMergeFields();
          return;
        }

        const templateFile: TemplateFile = TemplateFile.build();
        templateFile.file = file;
        templateFile.templateId = this.templateId;
        this.templateFileService
          .saveTemplateFile([templateFile])
          .subscribe((res) => {
            if (!res || !res.data || !res.data.length) {
              this.fileNameChange = false;
              return;
            }
            this.fileName = temp.name;
            this.templateFile = res.data[0];
            this.toast.success(
              this.message.getMessage("messages.upload_success")
            );
            this.fileIsError = null;
            if (file.mergeFields) {
              const listFieldConfig =
                this.createDefaultFieldConfigsFromMergeFields(
                  JSON.parse(file.mergeFields)
                );
              if (listFieldConfig.length) {
                const listTemplateFieldConfig: TemplateFieldConfig[] =
                  listFieldConfig.map((fieldConfig) => {
                    const templateFieldConfig: TemplateFieldConfig =
                      TemplateFieldConfig.build();
                    templateFieldConfig.fieldConfig = fieldConfig;
                    templateFieldConfig.templateId = this.templateId;
                    return templateFieldConfig;
                  });
                this.templateFieldConfigService
                  .saveAllTemplateFieldConfig(
                    listTemplateFieldConfig,
                    this.templateId
                  )
                  .subscribe((resp) => {
                    if (!resp || !resp.data) {
                      return;
                    }
                    this.appFieldConfig.initData();
                  });
              }
            }
          });
      });
    this.checkRequiredFile.subscribe((res) => {
      this.requiredFileError = res;
    });
  }

  getBase64(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  createDefaultFieldConfigsFromMergeFields(
    mergeFields: any
  ): Array<FieldConfig> {
    const arrFieldConfig: FieldConfig[] = [];
    let index = this.appFieldConfig.dataCache.length + 1;
    for (const mergeFieldObject of mergeFields) {
      if (mergeFieldObject.isGroup) {
        // tạo group
        const parent: FieldConfig = FieldConfig.build();
        parent.group = true;
        parent.multiple = true;
        parent.startGroup = mergeFieldObject.startGroup
          ? mergeFieldObject.startGroup
          : null;
        parent.endGroup = mergeFieldObject.endGroup
          ? mergeFieldObject.endGroup
          : null;
        const mergeFieldGroup = mergeFieldObject.startGroup
          ? mergeFieldObject.startGroup
          : mergeFieldObject.endGroup
            ? mergeFieldObject.startGroup
            : null;
        parent.name = mergeFieldGroup
          .replace(/END_|START_/g, "")
          .replace(/_/g, " ");
        parent.children = mergeFieldObject.children.map((child, indexChild) => {
          const childFieldConfig = this.createDefaultFieldConfigByMergeField(
            child.mergeField
          );
          childFieldConfig.orderNo = indexChild + 1;
          return childFieldConfig;
        });
        parent.orderNo = index;
        arrFieldConfig.push(parent);
        index++;
      } else {
        const fieldConfig: FieldConfig =
          this.createDefaultFieldConfigByMergeField(
            mergeFieldObject.mergeField
          );
        fieldConfig.orderNo = index;
        arrFieldConfig.push(fieldConfig);
        index++;
      }
    }
    return arrFieldConfig;
  }

  createDefaultFieldConfigByMergeField(mergeField: string): FieldConfig {
    const dataType = this.dcFieldConfigService.dataType
      ? this.dcFieldConfigService.dataType
      : [];
    const fieldType = this.dcFieldConfigService.fieldType
      ? this.dcFieldConfigService.fieldType
      : [];
    const fieldConfig: FieldConfig = FieldConfig.build();
    fieldConfig.mergeField = mergeField;
    fieldConfig.name = mergeField.replace(/_/g, " ");
    fieldConfig.dataType = dataType.find((dt) => dt.code === "input");
    fieldConfig.type = fieldType.find((ft) => ft.code === "textbox");

    return fieldConfig;
  }

  previewFile() {
    this.disableButtonForm = true;
    this.documentTypeService
      .checkPermission(this.documentTypeId)
      .subscribe((rs) => {
        if (rs && rs.code === ErrorCode.NotPermissionTemplate) {
          this.toast.error(this.message.getMessage('messages.check_permission'));
          return;
        }
        if (rs && rs.success) {
          this.templateFileService
            .getContentFileByUrl({
              type: "TEMPLATE_PDF",
              url: this.templateFile.file.pdfUrl,
            })
            .subscribe((response) => {
              if (!response) {
                return;
              }
              const dialog = this.dialog.open(DialogPreviewPdfComponent, {
                width: "80%",
                data: {
                  file: response,
                  name: this.documentTemplate.name,
                },
              });

              dialog.afterClosed().subscribe((res) => {
                this.disableButtonForm = false;
              });
            });
        }
      });
  }

  showErrorFile(error: string): void {
    let contentDialog;
    switch (error) {
      case "oversize":
        contentDialog = this.message.getMessage(
          "document_template.error_oversize"
        );
        break;
      case "file_type":
        contentDialog = this.message.getMessage(
          "document_template.error_file_type_docx"
        );
        break;
      case "difference":
        contentDialog = this.message.getMessage(
          "document_template.error_difference"
        );
        break;
      default:
        break;
    }
    if (contentDialog) {
      this.disableButtonForm = true;
      const dialog = this.dialog.open(DialogErrorComponent, {
        width: "50%",
        data: contentDialog,
      });
      dialog.afterClosed().subscribe((res) => {
        this.disableButtonForm = false;
      });
    }
  }

  resetFieldConfig(action: "get" | "reset" | "reload") {
    const ids = this.appFieldConfig.dataCache.map((fieldConfig) => {
      return fieldConfig.templateFieldConfigId;
    });
    if (ids.length) {
      this.templateFieldConfigService
        .deleteTemplateFieldConfig(ids)
        .subscribe((res) => {
          this.appFieldConfig.dataCache = [];
          this.saveTemplateField(action);
        });
      return;
    }
    this.saveTemplateField(action);
  }

  saveTemplateField(action: "get" | "reset" | "reload") {
    let textMessage;
    switch (action) {
      case "get":
        textMessage = "messages.get_merge_field";
        break;
      case "reset":
        textMessage = "messages.reset_merge_field";
        break;
      case "reload":
        textMessage = "messages.reload_merge_field";
        break;
      default:
        break;
    }
    const listFieldConfig = this.createDefaultFieldConfigsFromMergeFields(
      this.templateFile.file.mergeFields
        ? JSON.parse(this.templateFile.file.mergeFields)
        : []
    );
    if (listFieldConfig.length) {
      const listTemplateFieldConfig: TemplateFieldConfig[] =
        listFieldConfig.map((fieldConfig) => {
          const templateFieldConfig: TemplateFieldConfig =
            TemplateFieldConfig.build();
          templateFieldConfig.fieldConfig = fieldConfig;
          templateFieldConfig.templateId = this.templateId;
          return templateFieldConfig;
        });
      this.templateFieldConfigService
        .saveAllTemplateFieldConfig(listTemplateFieldConfig, this.templateId)
        .subscribe((response) => {
          if (!response || !response.data) {
            return;
          }
          this.appFieldConfig.initData();
          this.toast.success(this.message.getMessage(textMessage));
        });
    } else {
      this.appFieldConfig.initData();
      this.toast.success(this.message.getMessage(textMessage));
    }
  }

  onClickReset() {
    this.documentTypeService
      .checkPermission(this.documentTemplate.id)
      .subscribe((res) => {
        if (res && res.code === ErrorCode.NotPermissionTemplate) {
          this.toast.error(this.message.getMessage('messages.check_permission'));
          return;
        }
        if (res && res.success) {
          this.disableButtonForm = true;
          const dialog = this.dialog.open(WarningComponent, {
            width: "40%",
            data: this.message.getMessage("messages.confirm_reset"),
          });
          dialog.afterClosed().subscribe((ref) => {
            this.disableButtonForm = false;
            if (ref) {
              this.resetFieldConfig("reset");
            }
          });
        }
      });
  }

  addFieldConfigWithMergeFields(reload?: boolean) {
    const mergeFields = this.templateFile.file.mergeFields
      ? JSON.parse(this.templateFile.file.mergeFields)
      : [];
    const listMergeFieldCache = [];
    const mergeFieldNeedCreate = [];
    const fieldInGroupNeedCreate = [];
    this.appFieldConfig.dataCache.forEach((item) => {
      if (item.mergeField) {
        listMergeFieldCache.push(item.mergeField);
      }
      if (item.children) {
        item.children.forEach((child) => {
          if (child.mergeField) {
            listMergeFieldCache.push(child.mergeField);
          }
        });
      }
    });
    for (const mergeFieldObject of mergeFields) {
      if (mergeFieldObject.mergeField) {
        // xu ly cho truong k phai group
        const findInListField = listMergeFieldCache.find(
          (mergeField) => mergeField === mergeFieldObject.mergeField
        );
        if (!findInListField) {
          mergeFieldNeedCreate.push(mergeFieldObject);
        }
      }
      // xu ly cho truong hop la group
      if (mergeFieldObject.isGroup) {
        const findGroupInListField = this.appFieldConfig.dataCache.find(
          (group) =>
            group.startGroup === mergeFieldObject.startGroup &&
            group.endGroup === mergeFieldObject.endGroup
        );
        if (!findGroupInListField) {
          mergeFieldNeedCreate.push(mergeFieldObject);
        } else {
          let indexChild = findGroupInListField.children.length;
          mergeFieldObject.children.forEach((child) => {
            const findChildInGroup = listMergeFieldCache.find(
              (mergeField) => mergeField === child.mergeField
            );
            if (!findChildInGroup) {
              const childFieldConfig =
                this.createDefaultFieldConfigByMergeField(child.mergeField);
              childFieldConfig.orderNo = indexChild + 1;
              childFieldConfig.parentId = findGroupInListField.fieldConfigId;
              indexChild++;
              fieldInGroupNeedCreate.push(childFieldConfig);
            }
          });
        }
      }
    }
    const api = [];
    if (mergeFieldNeedCreate.length) {
      const listFieldConfig =
        this.createDefaultFieldConfigsFromMergeFields(mergeFieldNeedCreate);
      if (listFieldConfig.length) {
        const listTemplateFieldConfig: TemplateFieldConfig[] =
          listFieldConfig.map((fieldConfig) => {
            const templateFieldConfig: TemplateFieldConfig =
              TemplateFieldConfig.build();
            templateFieldConfig.fieldConfig = fieldConfig;
            templateFieldConfig.templateId = this.templateId;
            return templateFieldConfig;
          });
        api.push(
          this.templateFieldConfigService.saveAllTemplateFieldConfig(
            listTemplateFieldConfig,
            this.templateId
          )
        );
      }
    }
    if (fieldInGroupNeedCreate.length) {
      api.push(
        this.dcFieldConfigService.saveFieldConfig(
          fieldInGroupNeedCreate,
          this.templateId
        )
      );
    }

    if (api.length) {
      forkJoin(api).subscribe((resSave: any[]) => {
        if (!resSave || !resSave.length) {
          return;
        }
        let checkError = false;
        let string = "";
        resSave.forEach((element) => {
          if (!element.success) {
            string = element.message;
            checkError = true;
          }
        });
        if (checkError) {
          this.toast.error(string);
        } else {
          const message = reload
            ? this.message.getMessage("messages.reload_merge_field_success")
            : this.message.getMessage("messages.get_merge_field_success");
          this.toast.success(message);
        }
        this.appFieldConfig.initData();
      });
    }
  }

  openDialogReloadMergeFields() {
    this.disableButtonForm = true;
    const dialog = this.dialog.open(WarningWithSkipComponent, {
      width: "40%",
      data: this.message.getMessage("messages.confirm_reload_merge_field"),
    });
    dialog.afterClosed().subscribe((ref) => {
      this.disableButtonForm = false;
      if (ref === "accept") {
        this.resetFieldConfig("reload");
      } else if (ref === "decline") {
        this.addFieldConfigWithMergeFields(true);
      }
    });
  }

  cancel() {
    this.disableButtonForm = true;
    if (this.templateInformationFormGroup.dirty || this.mode === "create") {
      const dialog = this.dialog.open(WarningComponent, {
        width: "40%",
        data: this.message.getMessage("messages.confirm_cancel"),
      });
      dialog.afterClosed().subscribe((ref) => {
        this.disableButtonForm = false;
        if (ref) {
          if (this.mode !== "create") {
            if (!window.history.length) {
              this.router.navigateByUrl("/home-enterprise/document-template");
            } else {
              this.location.back();
            }
            return;
          }
          this.clearDraft(true);
        }
      });
      return;
    }
    if (!window.history.length) {
      this.router.navigateByUrl("/home-enterprise/document-template");
    } else {
      this.location.back();
    }
  }

  clearDraft(clear?: boolean) {
    if (!clear) {
      if (!window.history.length) {
        this.router.navigateByUrl("/home-enterprise/document-template");
      } else {
        this.location.back();
      }
    }
    this.documentTemplateService
      .deleteDocumentTemplate(this.documentTemplate.id)
      .subscribe((res) => {
        if (!res || !res.data) {
          return;
        }
        this.toast.success(
          this.message.getMessage("messages.delete_draft_success")
        );
        if (clear) {
          if (!window.history.length) {
            this.router.navigateByUrl("/home-enterprise/document-template");
          } else {
            this.location.back();
          }
        }
      });
  }

  openDialogForFile() {
    if (this.fileIsError) {
      this.errorForFile.subscribe((res) => {
        this.showErrorFile(res);
      });
    } else {
    }
  }
  onClickClearDraft() {
    this.disableButtonForm = true;
    const dialog = this.dialog.open(WarningComponent, {
      width: "40%",
      data: this.message.getMessage("messages.confirm_clear_draft"),
    });
    dialog.afterClosed().subscribe((ref) => {
      this.disableButtonForm = false;
      if (ref) {
        this.clearDraft(true);
      }
    });
  }

  clickNameFile() {
    if (!this.fileIsError) {
      this.documentTypeService
        .checkPermission(this.documentTypeId)
        .subscribe((rs) => {
          if (rs && rs.code === ErrorCode.NotPermissionTemplate) {
            this.toast.error(this.message.getMessage('messages.check_permission'));
            return;
          }
          if (rs && rs.success) {
            this.templateFileService
              .getContentFileByUrl({
                type: "TEMPLATE",
                url: this.templateFile.file.url,
              })
              .subscribe((res) => {
                if (!res) {
                  return;
                }
                if (res && res.code === ErrorCode.NotPermissionTemplate) {
                  this.toast.error(this.message.getMessage('messages.check_permission'));
                  return;
                }
                const blobUrl = URL.createObjectURL(res);
                var a = document.createElement("a");
                a.href = blobUrl;
                a.download = this.templateFile.file.name;
                a.click();
              });
          }
        });
    } else {
      this.showErrorFile(this.fileIsError);
    }
  }

  onClickIconError() {
    this.showErrorFile(this.fileIsError);
  }

  getDataForCreateMergeField() {
    if (!this.dcFieldConfigService.dataType.length) {
      forkJoin([
        this.dcFieldConfigService.getDataTypes(),
        this.dcFieldConfigService.getFieldTypes(),
      ]).subscribe((response) => {
        if (!response || !response.length) {
          return;
        }
        this.dcFieldConfigService.dataType = response[0].data;
        this.dcFieldConfigService.fieldType = response[1].data;
      });
    }
  }

  searchDocumentType() {
    this.listTypes = this.searchTypeCtrl.valueChanges.pipe(
      startWith(""),
      map((value) => {
        if (!value) {
          return this.listServiceTypes;
        }
        return this.listServiceTypes.filter((st) => {
          const optionLabel = `${st.name}`;
          return optionLabel.toLowerCase().includes(value.trim().toLowerCase());
        });
      })
    );
  }

  checkValidate() {
    if (!this.templateFile) {
      this.requiredFileError = true;
    }
    this.accordion.openAll();
  }

  focusOut(field: string) {
    const value = this.templateInformationFormGroup.get(field).value
      ? this.templateInformationFormGroup.get(field).value.trim()
      : null;
    this.templateInformationFormGroup.get(field).patchValue(value);
  }

  createTplModal(
    tplTitle: TemplateRef<{}>,
    tplContent: TemplateRef<{}>,
    tplFooter: TemplateRef<{}>
  ): void {
    this.tplModal = this.modalService.create({
      nzTitle: tplTitle,
      nzContent: tplContent,
      nzFooter: tplFooter,
      nzMaskClosable: true,
      nzClosable: true,
      nzOnOk: () => console.log("Click ok"),
    });
  }

  destroyTplModal(): void {
    setTimeout(() => {
      this.tplModal.destroy();
    }, 300);
  }

  checkErrorCodeApi(response: {
    code: string;
    message: string;
    success: boolean;
  }): void {
    if (response && response.code === ErrorCode.DocumentNotExist) {
      this.toast.error(this.message.getMessage("messages.check_permission"));
      this.notPermission = true;
    } else if (response && response.code === ErrorCode.CannotDecode) {
      this.toast.error(this.message.getMessage("messages.error_proccessing"));
      this.notPermission = true;
    }
  }

  sortOrderApproveSign() {
    let newOrder = 0;
    let RECORD_USER_APPROVE = [...this.OLD_RECORD_USER_PERFORM_SIGN.filter((item: any) => item.role == EnumRoleUser.USER_APPROVER)] as any;
    let RECORD_USER_SIGN = [...this.OLD_RECORD_USER_PERFORM_SIGN.filter((item: any) => item.role == EnumRoleUser.USER_SIGN)] as any;

    if(RECORD_USER_APPROVE.length) {
      RECORD_USER_APPROVE = RECORD_USER_APPROVE.sort((a, b) => {
        return a.order - b.order;
      });
  
      RECORD_USER_APPROVE = RECORD_USER_APPROVE.map((item, index) => {
        if(index === 0) {
          newOrder = 1;
          return {
            ...item,
            order: 1
          }
        } else {
          if(item.order !== RECORD_USER_APPROVE[index -1].order) {
            newOrder++;
          }
          return {
            ...item,
            order: newOrder
          }
        }
      });
  
      RECORD_USER_SIGN = RECORD_USER_SIGN.map((item) => ({
        ...item,
        order: RECORD_USER_APPROVE[RECORD_USER_APPROVE.length - 1].order + 1
      }))
    }

    const RECORD_USER_PERFORM_SIGN = RECORD_USER_APPROVE.concat(RECORD_USER_SIGN);

    this.OLD_RECORD_USER_PERFORM_SIGN = RECORD_USER_PERFORM_SIGN;
  }

  setDataSignConfig(signConfig: any) {
    let newDataSignConfig = { ...signConfig };
    if(newDataSignConfig.resize === null || newDataSignConfig.resize === undefined) {
      newDataSignConfig = { ...newDataSignConfig, resize: false };
    }
    if(newDataSignConfig.showImage === null || newDataSignConfig.showImage === undefined) {
      newDataSignConfig = { ...newDataSignConfig, showImage: true };
    }
    return newDataSignConfig;
  }
  
  selectedChange(event) {
    const objectServiceType = this.listServiceTypes.find(item => item.id == event.value);
    if (objectServiceType) {
      this.selectedServiceType = objectServiceType;
    } else {
      this.selectedServiceType = null;
    }
  }

}
